export enum untilTypeName {
  TRIGGER = 'trigger',
  TIMER = 'timer',
}